import type { Language, Locale } from '@seek/melways-sites';

export const convertMelwaysLocale = (melwaysLocale: Locale | Language) =>
  melwaysLocale.replace('-', '_');
